export default __webpack_public_path__ + "static/cp-components-mobile-4a5aca8b37dc439ca0721c8944754412.jpg";